// eslint-disable-next-line no-restricted-imports
import { Paper as PaperMui, withStyles, Theme, PaperProps } from '@material-ui/core';
import { Styles } from '@material-ui/styles/withStyles';

export const paperStyle: Styles<Theme, PaperProps, 'root'> = ({ palette }) => ({
  root: {
    borderRadius: 0,
    border: `solid ${palette.grey[500]} 1px`,
  },
});

export const Paper = withStyles<'root'>(paperStyle)(PaperMui);
